import { defineMessages } from 'react-intl';

import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import alignCenterSVG from '@plone/volto/icons/align-center.svg';
import alignLeftSVG from '@plone/volto/icons/align-left.svg';

const messages = defineMessages({
  alignText: {
    id: 'Align text',
    defaultMessage: 'Align text',
  },
  left: {
    id: 'Left',
    defaultMessage: 'Left',
  },
  centered: {
    id: 'Centered',
    defaultMessage: 'Centered',
  },
});

export const alignTextStyleSchema = ({ schema, formData, intl }) => {
  addStyling({ schema, intl });
  schema.properties.styles.schema.fieldsets[0].fields = [
    ...schema.properties.styles.schema.fieldsets[0].fields,
    '--text-align',
  ];
  schema.properties.styles.schema.properties['--text-align'] = {
    title: intl.formatMessage(messages.alignText),
    widget: 'buttons',
    default: 'left',
    actionsInfoMap: {
      left: [alignLeftSVG, intl.formatMessage(messages.left)],
      center: [alignCenterSVG, intl.formatMessage(messages.centered)],
    },
  };
  schema.properties.styles.schema.properties['--text-align'].actions = [
    'left',
    'center',
  ];

  return schema;
};
